import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './InteractiveBanner.css';
import React from 'react';
import { get, getPageThemeColors, getColorByTheme, canUseDOM } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { convertToAnalyticObject } from '../../utils/analytics';
import { stylesOldCarousel } from '../../utils/OldCarouselDotsStyles';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import RouterLink from '../atoms/RouterLink';
import { usePageZoom } from '../../utils/hooks/usePageZoom';
export var InteractiveBanner = function InteractiveBanner(_ref) {
  var fields = _ref.fields,
    rendering = _ref.rendering,
    children = _ref.children,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var imageSrc = get(fields, 'data.item.gradient.jss.value.src');
  var imageAlt = get(fields, 'data.item.gradient.jss.value.alt');
  var timingJssValue = get(fields, 'data.item.timing.jss.value', 4000);
  var timingJssNumber = Number(timingJssValue);
  var timing = timingJssNumber < 4000 ? 4000 : timingJssNumber;
  var slides = get(fields, 'data.item.slides.targetItems') || [];
  var isOneItemSlider = slides.length === 1;
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    autoplay = _React$useState2[0],
    setAutoplay = _React$useState2[1];
  var _React$useState3 = React.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    iconplay = _React$useState4[0],
    setIconPlay = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isTablet = _React$useState6[0],
    setIsTablet = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isMobile = _React$useState8[0],
    setIsMobile = _React$useState8[1];
  var _React$useState9 = React.useState(''),
    _React$useState0 = _slicedToArray(_React$useState9, 2),
    activeBannerTitle = _React$useState0[0],
    setActiveBannerTitle = _React$useState0[1];
  // const activeBannerTitle = React.useRef('') 
  var _usePageZoom = usePageZoom(400),
    zoomLevel = _usePageZoom.zoomLevel,
    zoomedDPR = _usePageZoom.zoomedDPR;

  // 400% zoom page
  var zoomBreakPoint = zoomedDPR;
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var _React$useState1 = React.useState(true),
    _React$useState10 = _slicedToArray(_React$useState1, 2),
    isVdsite = _React$useState10[0],
    setIsVdsite = _React$useState10[1];
  var checkIsTablet = function checkIsTablet() {
    var condition = canUseDOM && window.innerWidth <= 992;
    var conditionMobile = canUseDOM && window.innerWidth <= 768;
    setIsTablet(condition);
    setIsMobile(conditionMobile);
  };
  React.useEffect(function () {
    if (canUseDOM) {
      window.addEventListener('resize', checkIsTablet);
      var interval = setInterval(checkIsTablet, 1000);
      return function () {
        window.removeEventListener('resize', checkIsTablet);
        clearInterval(interval);
      };
    }
  }, []);
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
    if (canUseDOM) {
      var header = document.querySelector('.dot-site-header');
      var interactiveBanner = document.querySelector('.m113-interactive-banner');
      if (header && interactiveBanner) {
        header.classList.add('transparency-mode');
      }
      return function () {
        if (header && interactiveBanner) {
          header.classList.remove('transparency-mode');
        }
      };
    }
  }, []);
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var variables = BackgroundColorHex ? {
    '--m113-interactive-banner-background-color': BackgroundColorHex,
    '--m113-interactive-banner-background-active-color': ActiveColorHex,
    '--m113-interactive-banner-color': ColorHex
  } : {
    '--m113-interactive-banner-background-color': selectedPrimaryColor,
    '--m113-interactive-banner-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m113-interactive-banner-color': getColorByTheme(selectedPrimaryColor)
  };
  Object.assign(variables, {
    '--m113-interactive-banner-timing': "".concat(timing / 1000, "s"),
    '--m113-interactive-banner-half-timing': "".concat(timing / 1000 / 2, "s")
  });
  if (!fields.data.item) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  if (!fields) {
    console.info('InteractiveBanner component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [InteractiveBanner component is empty: please provide data source]");
    }
    return null;
  }
  var renderMediaPlaceholder = function renderMediaPlaceholder() {
    return /*#__PURE__*/React.createElement(Placeholder, {
      name: "dot-interactive-banner",
      rendering: rendering,
      bannerSlideTitle: activeBannerTitle
    });
  };
  var renderImage = function renderImage(src, alt, image, initialHeight, innerWidth) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, canUseDOM && /*#__PURE__*/React.createElement(React.Fragment, null, src && /*#__PURE__*/React.createElement("picture", null, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 992px)",
      srcSet: "".concat(src).concat(src.includes('?') ? '&' : '?', "cw=").concat(innerWidth, "&ch=").concat(initialHeight)
    }), /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 768px)",
      srcSet: "".concat(src).concat(src.includes('?') ? '&' : '?', "cw=1280&ch=900")
    }), /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 480px)",
      srcSet: "".concat(src).concat(src.includes('?') ? '&' : '?', "cw=768&ch=900")
    }), /*#__PURE__*/React.createElement("img", {
      src: "".concat(src).concat(src.includes('?') ? '&' : '?', "cw=480&ch=900"),
      alt: alt ? alt : '',
      "aria-hidden": "true",
      "aria-label": alt
    }))), pageEditing && /*#__PURE__*/React.createElement(Image, {
      editable: true,
      field: image
    }));
  };
  var renderItems = function renderItems() {
    if (slides.length) {
      return slides.map(function (item) {
        var imageSrc = get(item, 'image.jss.value.src');
        var imageHeight = get(item, 'image.jss.value.height');
        var imageWidth = get(item, 'image.jss.value.width');
        var imageAlt = get(item, 'image.jss.value.alt');
        var title = get(item, 'title.jss.value');
        var description = get(item, 'description.jss.value');
        var ctaLabel1 = get(item, 'ctaLabel1.jss.value');
        var ctaLink1Href = get(item, 'ctaLink1.jss.value.href');
        var ctaLink1Id = get(item, 'ctaLink1.jss.value.id');
        var ctaLink1Text = get(item, 'ctaLink1.jss.value.text');
        var ctaLink1Class = get(item, 'ctaLink1.jss.value.class');
        var ctaLabel2 = get(item, 'ctaLabel2.jss.value');
        var ctaLink2Href = get(item, 'ctaLink2.jss.value.href');
        var ctaLink2Text = get(item, 'ctaLink2.jss.value.text');
        var ctaLink2Id = get(item, 'ctaLink2.jss.value.id');
        var ctaLink2Class = get(item, 'ctaLink2.jss.value.class');
        return /*#__PURE__*/React.createElement("div", {
          className: "m113-interactive-banner__carousel-slide",
          key: item.id
        }, /*#__PURE__*/React.createElement("div", {
          className: "slide-bg"
        }, imageSrc && renderImage("".concat(imageSrc), imageAlt, get(item, 'image'), imageHeight, imageWidth)), /*#__PURE__*/React.createElement("div", {
          className: "module-group"
        }, /*#__PURE__*/React.createElement("div", {
          className: "module"
        }, title && /*#__PURE__*/React.createElement("h3", {
          className: "slide-title h3"
        }, title), description && /*#__PURE__*/React.createElement("p", {
          className: "slide-desc"
        }, description), /*#__PURE__*/React.createElement("div", {
          className: "slide-btns"
        }, ctaLabel1 && /*#__PURE__*/React.createElement(RouterLink, {
          className: "".concat(ctaLink1Class, " slide-cta btn main"),
          href: ctaLink1Href,
          key: ctaLink1Id,
          onClick: function onClick() {
            tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navigationPlayAnalytics'], params), [title, ctaLabel1]);
          },
          dataCy: ctaLink1Text,
          linktype: "external",
          openInSameTab: true
        }, ctaLabel1, /*#__PURE__*/React.createElement("svg", {
          width: "17",
          className: "slide-cta-icon",
          height: "8",
          viewBox: "0 0 17 8",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/React.createElement("path", {
          d: "M16.3536 4.35355C16.5488 4.15829 16.5488 3.84171 16.3536 3.64645L13.1716 0.464466C12.9763 0.269204 12.6597 0.269204 12.4645 0.464466C12.2692 0.659728 12.2692 0.976311 12.4645 1.17157L15.2929 4L12.4645 6.82843C12.2692 7.02369 12.2692 7.34027 12.4645 7.53553C12.6597 7.7308 12.9763 7.7308 13.1716 7.53553L16.3536 4.35355ZM0 4.5H16V3.5H0V4.5Z",
          fill: "white"
        }))), ctaLabel2 && /*#__PURE__*/React.createElement(RouterLink, {
          className: "".concat(ctaLink2Class, " slide-cta btn"),
          href: ctaLink2Href,
          key: ctaLink2Id,
          onClick: function onClick() {
            tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navigationPlayAnalytics'], params), [title, ctaLabel2]);
          },
          dataCy: ctaLink2Text,
          linktype: "external",
          openInSameTab: true
        }, ctaLabel2)))));
      });
    } else {
      return /*#__PURE__*/React.createElement("div", null);
    }
  };
  var render1Slide = function render1Slide() {
    if (slides.length) {
      var item = slides[0];
      var _imageSrc = get(item, 'image.jss.value.src');
      var imageHeight = get(item, 'image.jss.value.height');
      var imageWidth = get(item, 'image.jss.value.width');
      var _imageAlt = get(item, 'image.jss.value.alt');
      var title = get(item, 'title.jss.value');
      var description = get(item, 'description.jss.value');
      var ctaLabel1 = get(item, 'ctaLabel1.jss.value');
      var ctaLink1Href = get(item, 'ctaLink1.jss.value.href');
      var ctaLink1Id = get(item, 'ctaLink1.jss.value.id');
      var ctaLink1Text = get(item, 'ctaLink1.jss.value.text');
      var ctaLink1Class = get(item, 'ctaLink1.jss.value.class');
      var ctaLabel2 = get(item, 'ctaLabel2.jss.value');
      var ctaLink2Href = get(item, 'ctaLink2.jss.value.href');
      var ctaLink2Text = get(item, 'ctaLink2.jss.value.text');
      var ctaLink2Id = get(item, 'ctaLink2.jss.value.id');
      var ctaLink2Class = get(item, 'ctaLink2.jss.value.class');
      return /*#__PURE__*/React.createElement("div", {
        className: "m113-interactive-banner-1-item m113-interactive-banner__carousel-slide"
      }, /*#__PURE__*/React.createElement("div", {
        className: "slide-bg"
      }, _imageSrc && renderImage("".concat(_imageSrc), _imageAlt, get(item, 'image'), imageHeight, imageWidth)), /*#__PURE__*/React.createElement("div", {
        className: "module-group"
      }, /*#__PURE__*/React.createElement("div", {
        className: "module"
      }, title && /*#__PURE__*/React.createElement("h3", {
        className: "slide-title h3"
      }, title), description && /*#__PURE__*/React.createElement("p", {
        className: "slide-desc"
      }, description), /*#__PURE__*/React.createElement("div", {
        className: "slide-btns"
      }, ctaLabel1 && /*#__PURE__*/React.createElement(RouterLink, {
        className: "".concat(ctaLink1Class, " slide-cta btn main"),
        href: ctaLink1Href,
        key: ctaLink1Id,
        onClick: function onClick() {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navigationPlayAnalytics'], params), [title, ctaLabel1]);
        },
        dataCy: ctaLink1Text,
        linktype: "external",
        openInSameTab: true
      }, ctaLabel1, /*#__PURE__*/React.createElement("svg", {
        width: "17",
        className: "slide-cta-icon",
        height: "8",
        viewBox: "0 0 17 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M16.3536 4.35355C16.5488 4.15829 16.5488 3.84171 16.3536 3.64645L13.1716 0.464466C12.9763 0.269204 12.6597 0.269204 12.4645 0.464466C12.2692 0.659728 12.2692 0.976311 12.4645 1.17157L15.2929 4L12.4645 6.82843C12.2692 7.02369 12.2692 7.34027 12.4645 7.53553C12.6597 7.7308 12.9763 7.7308 13.1716 7.53553L16.3536 4.35355ZM0 4.5H16V3.5H0V4.5Z",
        fill: "white"
      }))), ctaLabel2 && /*#__PURE__*/React.createElement(RouterLink, {
        className: "".concat(ctaLink2Class, " slide-cta btn"),
        href: ctaLink2Href,
        key: ctaLink2Id,
        onClick: function onClick() {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navigationPlayAnalytics'], params), [title, ctaLabel2]);
        },
        dataCy: ctaLink2Text,
        linktype: "external",
        openInSameTab: true
      }, ctaLabel2)))));
    } else {
      return /*#__PURE__*/React.createElement("div", null);
    }
  };
  var handleAutoPlay = function handleAutoPlay() {
    setAutoplay(function (a) {
      return !a;
    });
    setIconPlay(function (a) {
      return !a;
    });
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navigationPlayAnalytics'], params), ["".concat(autoplay ? 'pause' : 'play'), activeBannerTitle]);
  };
  var handleSetActiveItem = function handleSetActiveItem(state) {
    if (slides[state.currentSlide]) {
      var currentSlideTitle = slides[state.currentSlide].title.jss.value;
      setActiveBannerTitle(currentSlideTitle);
    }
  };
  var autoplayBtn = function autoplayBtn() {
    return isOneItemSlider ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "m113-interactive-banner__autoplay ".concat(!iconplay && 'paused', " ").concat(isTablet ? 'tablet' : ''),
      onClick: function onClick() {
        return handleAutoPlay();
      }
    }, /*#__PURE__*/React.createElement("div", {
      id: "container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "icon ".concat(!iconplay && 'paused')
    }), iconplay ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      id: "halfclip"
    }, /*#__PURE__*/React.createElement("div", {
      className: "halfcircle",
      id: "clipped"
    })), /*#__PURE__*/React.createElement("div", {
      className: "halfcircle",
      id: "fixed"
    })) : /*#__PURE__*/React.createElement(React.Fragment, null)));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "container m113-interactive-banner ".concat(zoomLevel >= zoomBreakPoint ? 'zoomed' : ''),
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "row m113-interactive-banner__carousel ".concat(zoomLevel >= zoomBreakPoint ? 'zoomed' : '')
  }, slides.length === 1 ? render1Slide() : /*#__PURE__*/React.createElement(CarouselProvider, {
    handleCustomAfterChange: function handleCustomAfterChange(data) {
      return handleSetActiveItem(data);
    }
  }, function (_ref2) {
    var renderCarousel = _ref2.renderCarousel,
      renderPreviousButton = _ref2.renderPreviousButton,
      renderNextButton = _ref2.renderNextButton,
      renderDots = _ref2.renderDots,
      state = _ref2.state;
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderCarousel(renderItems(), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 0
          },
          items: 1
        },
        mobile: {
          breakpoint: {
            max: 1023,
            min: 0
          },
          items: 1
        }
      },
      autoPlay: autoplay,
      autoPlaySpeed: timing,
      infinite: true
    }), isTablet ? autoplayBtn() : null, isOneItemSlider ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement("div", {
      className: "m113-interactive-banner__carousel__controls-sec ".concat(rtl ? 'btn-group-rtl' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "m113-interactive-banner__carousel-btn-left"
    }, renderPreviousButton(function () {
      if (autoplay) {
        setIconPlay(false);
        setTimeout(function () {
          setIconPlay(true);
        }, 0);
      }
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navigationOperatingOptionsAnalytics'], params), 'previous');
    }, false, true)), !isTablet ? autoplayBtn() : null, /*#__PURE__*/React.createElement("div", {
      className: "m113-interactive-banner___pagination-dots"
    }, renderDots(function () {
      if (autoplay) {
        setIconPlay(false);
        setTimeout(function () {
          setIconPlay(true);
        }, 0);
      }
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navigationBubblesAnalytics'], params));
    })), /*#__PURE__*/React.createElement("div", {
      className: "m113-interactive-banner__carousel-btn-right"
    }, renderNextButton(function () {
      if (autoplay) {
        setIconPlay(false);
        setTimeout(function () {
          setIconPlay(true);
        }, 0);
      }
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navigationOperatingOptionsAnalytics'], params), 'next');
    }, false, true))));
  }), /*#__PURE__*/React.createElement("div", {
    className: "mouse mouse-1"
  })), /*#__PURE__*/React.createElement("div", {
    className: "placeholder-wrapper ".concat(zoomLevel >= zoomBreakPoint ? 'zoomed' : '')
  }, process.env.STORYBOOK_MODE ? children : renderMediaPlaceholder())));
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl,
    anchorUrlParameter = _ref3.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    removePadding: true,
    removePaddingInside: true,
    removePaddingTop: true,
    removePaddingBottom: true,
    className: " ".concat(commonStyles, " ").concat(stylesOldCarousel, "  ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "c15jigs1";
var ltrStyles = "l133nq8g";
var rtlStyles = "r8d3vhw";
export default InteractiveBanner;